export default "__VITE_ASSET__CSWSt63L__"